module.exports = __webpack_public_path__ + "static/img/index_swper_03.d14e6d1f.png";